module.exports = __webpack_public_path__ + "img/icon-sb-buy-now-160x106.5449a10.svg";